/**
 * Stamps the Devello Tech footer on every page of a jsPDF document (invoice PDFs from html2canvas).
 */

import poweredByMark from '../ChatGPT Image Jun 26, 2025, 12_35_25 AM.png';
import { devWarn } from './logger';

async function imageSrcToDataUrl(src) {
  if (!src) return '';
  if (String(src).startsWith('data:')) return src;
  try {
    const res = await fetch(src, { mode: 'cors', credentials: 'omit' });
    if (!res.ok) return '';
    const blob = await res.blob();
    return await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onloadend = () => resolve(typeof fr.result === 'string' ? fr.result : '');
      fr.onerror = () => reject(new Error('read failed'));
      fr.readAsDataURL(blob);
    });
  } catch {
    return '';
  }
}

/**
 * @param {import('jspdf').jsPDF} pdf
 */
export async function stampDevelloFooterOnAllPages(pdf) {
  const dataUrl = await imageSrcToDataUrl(poweredByMark);
  const pageCount = pdf.getNumberOfPages();
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  const marginBottomMm = 9;
  const fontSizePt = 12;
  const text = 'Powered by Devello Tech';
  const imgWmm = 6.5;
  const imgHmm = 6.5;
  const gapMm = 2.5;

  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(fontSizePt);
  pdf.setTextColor(71, 85, 105);

  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);
    const textWmm = pdf.getTextWidth(text);
    const hasImg = Boolean(dataUrl);
    const blockWmm = (hasImg ? imgWmm + gapMm : 0) + textWmm;
    const startX = (pageW - blockWmm) / 2;
    const textBaselineY = pageH - marginBottomMm;

    if (hasImg) {
      try {
        const imgTopY = textBaselineY - imgHmm + 1.5;
        pdf.addImage(dataUrl, 'PNG', startX, imgTopY, imgWmm, imgHmm);
      } catch (e) {
        devWarn('[invoice PDF] footer logo:', e?.message || e);
      }
    }

    const textX = startX + (hasImg ? imgWmm + gapMm : 0);
    pdf.text(text, textX, textBaselineY);
  }
}
